class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.searchWrapper = this.closest("[data-header-search-wrapper]");
        this.searchInput = this.searchWrapper.querySelector("[data-header-search-input]");
        this.openDetails = this.searchWrapper.querySelector("[data-header-search-opener]");
        this.searchForm = this.searchWrapper.querySelector("#header-search-form");
        this.openDetails.addEventListener("toggle", this.updateSearchItems.bind(this));
        this.searchInput.addEventListener("focus", () => {
            this.openDetails.open = true;
        });

        this.searchInput.addEventListener("input", debounce(() => {
            if (!this.searchInput.value.trim()) {
                const queryList = this.querySelector("[data-predictive-search-list]");
                const queryButton = this.querySelector("[data-predictive-search-button]");

                if (queryList && queryButton) {
                    queryList.classList.remove("show");
                    queryButton.classList.remove("show");
                    this.classList.remove("show")
                } else {
                    if (!queryList.classList.contains("show")) queryList.classList.add("show");
                    if (!queryButton.classList.contains("show")) queryButton.classList.add("show");
                    if (!this.classList.contains("show")) this.classList.add("show")
                }

                return null;
            } else {
                if (!this.classList.contains("show")) this.classList.add("show")
            }

            this.getSearchResults(this.searchInput.value.trim());
        }).bind(this), 500)
    }

    updateSearchItems() {
        const button = this.querySelector("[data-predictive-search-button]");
        const list = this.querySelector("[data-predictive-search-list]")

        if (!this.openDetails.hasAttribute("open")) {
            this.classList.remove("show")

            if (list && list.classList.contains("show")) list.classList.remove("show")
            if (button) button.classList.remove("show")
        } else {
            if (this.searchInput.value.trim()) {
                if (!this.classList.contains("show")) this.classList.add("show")
                if (list && !list.classList.contains("show")) list.classList.add("show")
                if (button && !button.classList.contains("show")) button.classList.add("show")
            }

            setTimeout(() => {
                this.searchInput.focus();
            }, 300)
        }
    }

    async getSearchResults(searchTerm) {
        const tempElement = document.createElement("div");
        const url = `${window.routes.predictive_search_url}?q=${searchTerm}&section_id=predictive-search`;
        const response = await fetchWithCache(url);
        tempElement.innerHTML = response;
        this.replaceChildren(...tempElement.querySelector("predictive-search").childNodes);
    }
}

if (!window.customElements.get("predictive-search")) {
    window.customElements.define("predictive-search", PredictiveSearch);
}